/*
  読みものドロワー(2026-09-07)
  初めて開いた時に TOP の 特集/ブログ セクションを Section Rendering API で取り、
  data-cec-* 属性から 2列×2行 と 1列×4行 を組み立てる。同じセッションでは結果を使い回す。
  ドロワーの出し入れ自体はテーマの drawer-component が担当。
*/
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cec-reading]');
  if (!drawer) return;

  var featId = drawer.getAttribute('data-cec-feature-id');
  var blogId = drawer.getAttribute('data-cec-blog-id');
  var featCount = parseInt(drawer.getAttribute('data-cec-feature-count') || '4', 10) || 4;
  var blogCount = parseInt(drawer.getAttribute('data-cec-blog-count') || '4', 10) || 4;
  var KEY = 'cec-reading:' + featId + ',' + blogId + ':' + (drawer.getAttribute('data-cec-feature-count') || '4') + '/' + (drawer.getAttribute('data-cec-blog-count') || '4');
  var loaded = false;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* TOP のカードに「CALL&amp;RESPONSE」のように実体参照のまま入力された文字があるので、
     一度だけ実体を戻してから esc する(そのままだと &amp;amp; になって「&amp;」と表示される) */
  var decoder = document.createElement('textarea');
  function decode(s) {
    decoder.innerHTML = String(s == null ? '' : s);
    return decoder.value;
  }

  /* セクション要素 → カード配列 */
  function parse(root, count) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cec-title]')).slice(0, count || 4).map(function (li) {
      return {
        title: decode(li.getAttribute('data-cec-title') || ''),
        excerpt: decode(li.getAttribute('data-cec-excerpt') || ''),
        link: li.getAttribute('data-cec-link') || '#',
        img: li.getAttribute('data-cec-img') || ''
      };
    });
    return {
      heading: decode(root.getAttribute('data-cec-heading') || ''),
      viewallLabel: decode(root.getAttribute('data-cec-viewall-label') || ''),
      viewallLink: root.getAttribute('data-cec-viewall-link') || '',
      items: items
    };
  }

  /* TOP のセクションを探す。data-section-id は「template--<番号>__anker_feature」のように
     テーマごとの番号が付くので、末尾の名前(__anker_feature)で照合する */
  function findSection(doc, key) {
    var all = doc.querySelectorAll('[data-cec-heading][data-section-id]');
    for (var i = 0; i < all.length; i++) {
      var id = all[i].getAttribute('data-section-id') || '';
      if (id === key || id.slice(-(key.length + 2)) === '__' + key) return all[i];
    }
    return null;
  }

  function renderHead(block, data) {
    var h = block.querySelector('[data-cec-heading]');
    var v = block.querySelector('[data-cec-viewall]');
    if (h && data.heading) h.textContent = data.heading;
    if (v) {
      if (data.viewallLink) v.setAttribute('href', data.viewallLink);
      if (data.viewallLabel) v.innerHTML = esc(data.viewallLabel) + '<span aria-hidden="true"> ›</span>';
    }
  }

  function renderFeature(data) {
    var block = drawer.querySelector('[data-cec-reading-feature]');
    var ul = block.querySelector('[data-cec-items]');
    renderHead(block, data);
    if (!data.items.length) { ul.innerHTML = '<li class="cec-rdrawer__empty">まだ記事がありません</li>'; return; }
    ul.innerHTML = data.items.map(function (it) {
      return '<li class="cec-rdrawer__gitem"><a class="cec-rdrawer__gcard" href="' + esc(it.link) + '">' +
        '<div class="cec-rdrawer__gmedia">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<p class="cec-rdrawer__gtitle">' + esc(it.title) + '</p>' +
        (it.excerpt ? '<p class="cec-rdrawer__gexcerpt">' + esc(it.excerpt) + '</p>' : '') +
        '</a></li>';
    }).join('');
  }

  function renderBlog(data) {
    var block = drawer.querySelector('[data-cec-reading-blog]');
    var ul = block.querySelector('[data-cec-items]');
    renderHead(block, data);
    if (!data.items.length) { ul.innerHTML = '<li class="cec-rdrawer__empty">まだ記事がありません</li>'; return; }
    ul.innerHTML = data.items.map(function (it) {
      return '<li class="cec-rdrawer__litem"><a class="cec-rdrawer__lcard" href="' + esc(it.link) + '">' +
        '<div class="cec-rdrawer__lmedia">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="cec-rdrawer__ltext"><p class="cec-rdrawer__ltitle">' + esc(it.title) + '</p>' +
        (it.excerpt ? '<p class="cec-rdrawer__lexcerpt">' + esc(it.excerpt) + '</p>' : '') +
        '</div></a></li>';
    }).join('');
  }

  function fail() {
    /* 取れなかった時は骨組みを消し、「すべて見る」だけ残す */
    drawer.querySelectorAll('[data-cec-items]').forEach(function (ul) { ul.innerHTML = ''; });
  }

  function applyDoc(doc) {
    var f = findSection(doc, featId);
    var b = findSection(doc, blogId);
    if (!f && !b) { fail(); return; }
    var data = { feature: f ? parse(f, featCount) : null, blog: b ? parse(b, blogCount) : null };
    applyData(data);
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }

  function applyData(data) {
    try {
      if (data.feature) renderFeature(data.feature); else fail();
      if (data.blog) renderBlog(data.blog);
      loaded = true;
    } catch (e) {
      fail();
    }
  }

  function load() {
    if (loaded) return;
    /* TOP にいる時はページの中身をそのまま使う(通信なし) */
    if (findSection(document, featId) || findSection(document, blogId)) {
      applyDoc(document);
      return;
    }
    var cached = null;
    try { cached = sessionStorage.getItem(KEY); } catch (e) {}
    if (cached) {
      try { applyData(JSON.parse(cached)); return; } catch (e) {}
    }
    /* それ以外は TOP を1回だけ取りに行く。Section Rendering API はテーマごとに変わる
       「template--番号__」付きの ID が要るため、TOP 本体から名前で探す方が壊れにくい */
    fetch('/', { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        applyDoc(doc);
      })
      .catch(fail);
  }

  /* テーマのドロワーが open イベントを出す。初回だけ取りに行く */
  drawer.addEventListener('open', load);

  /* 2026-10-19 計測。押されたリンクを「特集 / ブログ」「記事 / すべて見る」に分けて送る。
     カスタムピクセル callec-collection-events が GA4 へ送る(イベント名 rdrawer_link_click)。
     ドロワーを開いた回数は下部ナビの bn_tab_click(action=drawer_reading)で数える */
  drawer.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    try {
      if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
      var t = document.body.className.match(/template-[\w-]+/);
      var area = a.closest('[data-cec-reading-feature]') ? 'feature' : (a.closest('[data-cec-reading-blog]') ? 'blog' : 'other');
      var li = a.closest('li');
      var position = li && li.parentNode ? Array.prototype.indexOf.call(li.parentNode.children, li) + 1 : 0;
      Shopify.analytics.publish('callec:rdrawer_link_click', {
        area: area,
        kind: a.hasAttribute('data-cec-viewall') ? 'viewall' : 'article',
        link: (a.getAttribute('href') || '').split('?')[0],
        position: position,
        template: t ? t[0] : ''
      });
    } catch (err) {
      // 計測の失敗で操作を止めない
    }
  });
})();
